interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const ClockIcon = (props: PropsType) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_101_449)">
        <path
          d="M14.0001 3.07191C15.2068 3.7686 16.2105 4.76833 16.912 5.97215C17.6135 7.17597 17.9885 8.54213 17.9997 9.93538C18.011 11.3286 17.6582 12.7007 16.9762 13.9157C16.2942 15.1307 15.3068 16.1465 14.1115 16.8626C12.9163 17.5787 11.5548 17.9702 10.1618 17.9984C8.76875 18.0266 7.39251 17.6904 6.16929 17.0233C4.94608 16.3562 3.91832 15.3811 3.18775 14.1947C2.45718 13.0083 2.04913 11.6517 2.004 10.2591L2 9.99991L2.004 9.74071C2.0488 8.35911 2.45084 7.01268 3.17093 5.83271C3.89101 4.65273 4.90456 3.67948 6.11276 3.00782C7.32097 2.33616 8.6826 1.98903 10.0649 2.00026C11.4472 2.0115 12.803 2.38071 14.0001 3.07191ZM10.0001 5.19991C9.80415 5.19994 9.61502 5.27188 9.46859 5.40209C9.32216 5.53229 9.22861 5.71171 9.20569 5.90631L9.20009 5.99991V9.99991L9.20729 10.1047C9.22553 10.2435 9.27987 10.3751 9.36489 10.4863L9.43449 10.5663L11.8345 12.9663L11.9097 13.0319C12.05 13.1408 12.2226 13.1998 12.4001 13.1998C12.5777 13.1998 12.7502 13.1408 12.8905 13.0319L12.9657 12.9655L13.0321 12.8903C13.141 12.75 13.2001 12.5775 13.2001 12.3999C13.2001 12.2223 13.141 12.0498 13.0321 11.9095L12.9657 11.8343L10.8001 9.66791V5.99991L10.7945 5.90631C10.7716 5.71171 10.678 5.53229 10.5316 5.40209C10.3852 5.27188 10.196 5.19994 10.0001 5.19991Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_101_449">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ClockIcon;
